import { Component, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest, interval  } from 'rxjs';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { Constants } from 'src/app/models/constants';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { DeploymentClass } from 'src/app/models/instance-class';
import { Attributes, Datazone, Permission } from 'src/app/models/principal/permission';
import { RouterSegments } from 'src/app/models/router-segments';
import { SolutionVersionsInfo } from 'src/app/models/service/solution-versions-info';
import { Tenant } from 'src/app/models/tenant/tenant';
import { AVAILABLE_STATE_ICON, ENV_PROGRESS_STATUS, ENVIRONMENT_STATUS_ICON, LastOperation } from 'src/app/models/instance/instance';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import moment from 'moment';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { DrModeDialogComponent } from 'src/app/components/dr-mode-dialog/dr-mode-dialog.component';
import { FeatureFlags } from 'src/app/models/constants/feature-flags.constant';
import { FeatureFlagsManagerService } from 'src/app/services/util/feature-flags-manager.service';
import { ActivityService } from 'src/app/services/api/activity.service';
import { ActivityProgressService } from 'src/app/services/util/activity-progress.service';
import { formatAvailabilityState, toUtcString } from 'src/app/services/util/utils';
import { EnvironmentActivityDetails } from '../../environment-details/environment-activity-details/environment-activity-details';
import { DisasterRecoveryService } from 'src/app/services/api/disaster-recovery.service';

const REQUIRED_PERMISSIONS = [
  { 
    key: PermissionKeys.BLUEPRINT_READ,
    action: Permissions.BLUEPRINT_READ
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_LIVE,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_DR_DATAZONE_LIVE,
    action: Permissions.INSTANCE_DR,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
    selector: 'app-disaster-recovery-instances',
    templateUrl: './disaster-recovery-instances.component.html',
    styleUrls: ['./disaster-recovery-instances.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ])
    ],
    standalone: false
})
export class DisasterRecoveryInstancesComponent   implements OnInit {
  private destroyRef = inject(DestroyRef);
  toUtcString = toUtcString;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  PermissionKeys = PermissionKeys;
  blueprintId: string;
  instanceId: string;
  blueprint: any;
  viewReleaseNotes: string;
  solution: any;
  solutionVersions: any[];
  instances: any[];
  serviceVersionsInfo: SolutionVersionsInfo;
  latestReleaseVersion: any;
  isAMR: boolean;
  tenantData: Tenant;
  latestServiceDefinitionVersion: any;
  isLive: boolean;
  selectedMenu: any;
  RouterSegments = RouterSegments;
  tenantId: any;
  classAInstaceDetails: any;
  sharedInstanceDetails: any;
  dataLoaded = false;
  Constants = Constants;
  count: any;
  instanceIdsObj: any;
  permissionsMap: { [key: string]: boolean };
  currentTime: number = Date.now();
  private featureFlagsManagerService = inject(FeatureFlagsManagerService);
  

  Permission = Permission;
  DeployStatus = DeployStatus;
  DrStates = {
    FAILOVER: "failover",
    PRE_FALLBACK: "pre_fallback",
    FALLBACK: "fallback",
    POST_FALLBACK: "post_fallback"
  }

  DrStatus = {
    FAILOVER_INPROGRESS: "failover_inprogress",
    PRE_FALLBACK_INPROGRESS: "pre_failback_applying",
    FALLBACK_INPROGRESS: "fallback_inprogress",
    POST_FALLBACK_INPROGRESS: "post_failback_applying"
  }

  DrActions: any = {
    FAILOVER: 'failover',
    PRE_FALLBACK: 'prefallback',
    FALLBACK: 'fallback',
    POST_FALLBACK: 'postfallback'
  };
  DrModes = {
    PLANNED: 'planned',
    UNPLANNED: 'unplanned'
  };

  statusText: { [key: string]: string } = {
    failover_inprogress: "DISASTER_RECOVERY.FAILOVER_INPROGRESS",
    pre_failback_applying: "DISASTER_RECOVERY.PRE-FALLBACK_INPROGRESS",
    fallback_inprogress: "DISASTER_RECOVERY.FALLBACK_INPROGRESS",
    post_failback_applying: "DISASTER_RECOVERY.POST-FALLBACK_INPROGRESS",
    [DeployStatus.FAILOVER_FAILED]: "DISASTER_RECOVERY.FAILOVER_FAILED",
    [DeployStatus.PRE_FAILBACK_FAILED]: "DISASTER_RECOVERY.PRE-FALLBACK_FAILED",
    [DeployStatus.FAILBACK_FAILED]: "DISASTER_RECOVERY.FALLBACK_FAILED",
    [DeployStatus.POST_FAILBACK_FAILED]: "DISASTER_RECOVERY.POST_FAILBACK_FAILED"
  }
  drStates = ["failover", "pre_fallback","fallback","post_fallback"];

  readonly DR_STEPS = [
    { key: this.DrStates.FAILOVER,     label: 'DISASTER_RECOVERY.FAIL_OVER' },
    { key: this.DrStates.PRE_FALLBACK, label: 'DISASTER_RECOVERY.PRE_FALLBACK' },
    { key: this.DrStates.FALLBACK,     label: 'DISASTER_RECOVERY.FALLBACK' },
    { key: this.DrStates.POST_FALLBACK,label: 'DISASTER_RECOVERY.POST_FALLBACK' }
  ];

  private readonly drInProgressStatusByState = {
    [this.DrStates.FAILOVER]:     this.DrStatus.FAILOVER_INPROGRESS,
    [this.DrStates.PRE_FALLBACK]: this.DrStatus.PRE_FALLBACK_INPROGRESS,
    [this.DrStates.FALLBACK]:     this.DrStatus.FALLBACK_INPROGRESS,
    [this.DrStates.POST_FALLBACK]:this.DrStatus.POST_FALLBACK_INPROGRESS
  };

private readonly drFailedStatusByState = {
  [this.DrStates.FAILOVER]:      DeployStatus.FAILOVER_FAILED,
  [this.DrStates.PRE_FALLBACK]:  DeployStatus.PRE_FAILBACK_FAILED,
  [this.DrStates.FALLBACK]:      DeployStatus.FAILBACK_FAILED,
  [this.DrStates.POST_FALLBACK]: DeployStatus.POST_FAILBACK_FAILED
};

private readonly statusIconMap: { [key: string]: string } = {
  [DeployStatus.DEPLOYED]: 'check_circle_filled',
  [this.DrStatus.FAILOVER_INPROGRESS]: 'spinner',
  [this.DrStatus.PRE_FALLBACK_INPROGRESS]: 'spinner',
  [this.DrStatus.FALLBACK_INPROGRESS]: 'spinner',
  [this.DrStatus.POST_FALLBACK_INPROGRESS]: 'spinner',
  [DeployStatus.FAILOVER_FAILED]: 'error',
  [DeployStatus.PRE_FAILBACK_FAILED]: 'error',
  [DeployStatus.FAILBACK_FAILED]: 'error',
  [DeployStatus.POST_FAILBACK_FAILED]: 'error',
  [DeployStatus.FAILED]: 'error'
};

private readonly statusClassMap: { [key: string]: string } = {
  [DeployStatus.DEPLOYED]: 'status-deployed',
  [this.DrStatus.FAILOVER_INPROGRESS]: 'status-inprogress',
  [this.DrStatus.PRE_FALLBACK_INPROGRESS]: 'status-inprogress',
  [this.DrStatus.FALLBACK_INPROGRESS]: 'status-inprogress',
  [this.DrStatus.POST_FALLBACK_INPROGRESS]: 'status-inprogress',
  [DeployStatus.FAILOVER_FAILED]: 'status-failed',
  [DeployStatus.PRE_FAILBACK_FAILED]: 'status-failed',
  [DeployStatus.FAILBACK_FAILED]: 'status-failed',
  [DeployStatus.POST_FAILBACK_FAILED]: 'status-failed',
  [DeployStatus.FAILED]: 'status-failed'
};

private readonly drStateDisplayText: { [key: string]: string } = {
  [this.DrStates.FAILOVER]: 'DISASTER_RECOVERY.FAIL_OVER',
  [this.DrStates.PRE_FALLBACK]: 'DISASTER_RECOVERY.PRE_FALLBACK',
  [this.DrStates.FALLBACK]: 'DISASTER_RECOVERY.FALLBACK',
  [this.DrStates.POST_FALLBACK]: 'DISASTER_RECOVERY.POST_FALLBACK'
};

  remainingTime: number;
  DrNotEligibleStatus = [DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.TERMINATION_FAILED, DeployStatus.DEPLOYING, DeployStatus.INITIALIZING, DeployStatus.CONFIGURING,
    DeployStatus.ADOPTING, DeployStatus.UPDATING, DeployStatus.TESTING, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING,
    DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.DELETING, DeployStatus.ENABLING, DeployStatus.DISABLING, DeployStatus.REMOVING, DeployStatus.FALLBACK_INPROGRESS, DeployStatus.FAILOVER_INPROGRESS,
    DeployStatus.PROVISIONING, DeployStatus.RESTORING, DeployStatus.RESIZING, DeployStatus.ABORTING, DeployStatus.TENANT_AGENT_CREATION_IN_PROGRESS, DeployStatus.COB_NOT_STARTED, DeployStatus.NOT_DEPLOYED];  
  isDrFeatureEnabled: boolean;
  readonly INSTANCE_DEPLOYED_STATES = [DeployStatus.DEPLOYED, DeployStatus.CONFIGURING,
    DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.UPDATED, DeployStatus.TESTED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED];

  breadcrumbItems: BreadcrumbItem[] = [];

  availableStateIcon = AVAILABLE_STATE_ICON;
  environmentStatusIcon = ENVIRONMENT_STATUS_ICON;
  envProgressStatus = ENV_PROGRESS_STATUS;
  formatAvailabilityState = formatAvailabilityState;

  constructor(
    private activatedRoute: ActivatedRoute,
    private blueprintsService: BlueprintsService,
    private solutionsService: SolutionsService,
    private instanceService: InstancesService,
    private solutionVersionsService: SolutionVersionsService,
    private toastrService: CustomToastrService,
    private tenantService: TenantService,
    private errorPageService: ErrorPageService,
    private sidenavService: SidenavService,
    public authService: AuthService,
    public permissionsService: PermissionsService,
    private activityService: ActivityService,
    public activityProgressService: ActivityProgressService,
    private dialog: MatDialog, private router: Router, private disasterRecoveryService: DisasterRecoveryService) {
    
  }

  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.DISASTER_RECOVERY';
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    const tenant = this.authService.principal.provider;
    if (!this.permissionsMap[PermissionKeys.BLUEPRINT_READ]) {
      this.router.navigate(['/', tenant, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.getTenantDetails();
    this.loadBlueprint();
    interval(1000)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(() => this.currentTime = Date.now());
  }

  getTenantDetails(): void {
    const tenantId = this.activatedRoute.snapshot.params.id;
    this.tenantService.getTenantDetails(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        this.tenantData = data;
        if (this.tenantData?.parameters?.hasSecondaryRegion && this.tenantData?.parameters?.hasSecondaryRegion === 'false') {
           this.router.navigate(['/', tenantId, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
        }
        this.sharedInstanceDetails = [];
        this.instanceIdsObj = {
          // sharedInfraInstance: data?.sharedInfra?.prod?.instanceId,
          sharedServicesInstance: data?.sharedServices?.prod?.instanceId
        }
        Object.keys(this.instanceIdsObj).forEach(key => {
          if (this.instanceIdsObj[key]) {
            this.getSharedInstanceDetails(this.instanceIdsObj[key]);
          }
        });
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  getSharedInstanceDetails(id: any, forceActivityLoad: boolean = false): void {
    this.instanceService.getInstanceDetails(id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.sharedInstanceDetails = [data];
      this.dataLoaded = true;
        if (forceActivityLoad || this.isInstanceInProgress(data)) {
        this.loadActivityDetails(data);
      }
    }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  // Checks whether the instance is currently in any failover or fallback operation
  isInstanceInProgress(instance: any): boolean {
    return instance?.status === this.DrStatus.FAILOVER_INPROGRESS || instance?.status === this.DrStatus.PRE_FALLBACK_INPROGRESS || instance?.status === this.DrStatus.FALLBACK_INPROGRESS || instance?.status === this.DrStatus.POST_FALLBACK_INPROGRESS;
  }

  // Returns the corresponding icon for the given status, or null if no icon is mapped.
  getStatusIcon(status: string): string | null {
    return this.statusIconMap[status] ?? null;
  }

  // Returns the CSS class mapped to the given status.
  getStatusClass(status: string): string {
    return this.statusClassMap[status];
  }

  // Returns the index of the instance's current DR state, or -1 if the state is not found.
  private stepIndexOf(instance: any): number {
    const state = this.getDrState(instance);
    return state ? this.drStates.indexOf(state) : -1;
  }

  // Checks whether the instance failed at the specified DR state step.
  private instanceFailedStep(instance: any, p: number): boolean {
    const index = this.stepIndexOf(instance);
    if (index !== p) { return false; }
    return instance?.status === this.drFailedStatusByState[this.drStates[p]];
  }

  // Checks whether any of the relevant instances failed at the specified DR state step.
  private stepFailed(p: number): boolean {
    return this.instanceFailedStep(this.sharedInstanceDetails?.[0], p)
        || this.instanceFailedStep(this.classAInstaceDetails?.[0], p);
  }

  // Returns the display text corresponding to the instance's current DR state
  getDrStateDisplay(instance: any): string {
  const state = this.getDrState(instance);
    return this.drStateDisplayText[state];
  }

  // Returns the resolved DR state index, ignoring stale state from a previous cycle when the counterpart has restarted.
  private resolvedStepIndex(instance: any, counterpart: any): number {
    const index = this.stepIndexOf(instance);
    const counterpartIdx = this.stepIndexOf(counterpart);
    const lastStepIdx = this.drStates.length - 1;

    const counterpartJustRestarted = counterpartIdx === 0;
    const thisIsStaleFromPreviousCycle = index === lastStepIdx && this.isOperationSuccessful(instance);

    if (counterpartJustRestarted && thisIsStaleFromPreviousCycle) {
      return -1;
    }
    return index;
  }

  // Checks whether the instance has successfully completed or passed the specified DR state step.
  private instancePassedStep(instance: any, counterpart: any, stepIndex: number): boolean {
    const index = this.resolvedStepIndex(instance, counterpart);
    if (index > stepIndex) { return true; }
    if (index === stepIndex) { return this.isOperationSuccessful(instance); }
    return false;
  }

  // Checks whether the instance is currently running at the specified DR state step.
  private instanceRunningStep(instance: any, counterpart: any, stepIndex: number): boolean {
    const index = this.resolvedStepIndex(instance, counterpart);
    if (index !== stepIndex) { return false; }
    return instance?.status === this.drInProgressStatusByState[this.drStates[stepIndex]];
  }

  // Checks whether both shared and class A instances have successfully completed the specified DR state step.
  private stepCompleted(stepIndex: number): boolean {
    const shared = this.sharedInstanceDetails?.[0];
    const classA = this.classAInstaceDetails?.[0];
    const sharedOk = shared ? this.instancePassedStep(shared, classA, stepIndex) : true;
    const classAOk = classA ? this.instancePassedStep(classA, shared, stepIndex) : true;
    return sharedOk && classAOk;
  }

  // Checks whether either the shared or class A instance is currently running at the specified DR state step.
  private stepRunning(stepIndex: number): boolean {
    const shared = this.sharedInstanceDetails?.[0];
    const classA = this.classAInstaceDetails?.[0];
    return (!!shared && this.instanceRunningStep(shared, classA, stepIndex))
        || (!!classA && this.instanceRunningStep(classA, shared, stepIndex));
  }

  // Checks whether a DR step has just completed successfully based on the instance status and update timestamp.
  isDrStepJustCompleted(instance: any): boolean {
  const drState = this.getDrState(instance);
  return instance?.status === DeployStatus.DEPLOYED &&
    (drState === this.DrStates.FAILOVER ||
     drState === this.DrStates.PRE_FALLBACK ||
     drState === this.DrStates.FALLBACK ||
     drState === this.DrStates.POST_FALLBACK) &&
    this.getDifferenceBetweenDates(instance?.dateUpdated);
  }

  // Determines whether padding should be removed for an instance that is in progress or has just completed a DR step.
  shouldRemovePadding(instance: any): boolean {
    return this.isInstanceInProgress(instance) || this.isDrStepJustCompleted(instance);
  }

  // Returns the index of the current DR step that is not yet completed.
  get currentDrStepPointer(): number {
    for (let pointer = 0; pointer < this.DR_STEPS.length; pointer++) {
      if (!this.stepCompleted(pointer)) {
        return pointer;
      }
    }
    return this.DR_STEPS.length;
  }

  // Determines the current status of a DR step based on its running, failed, completed, and upcoming state.
  getStepStatus(stepIndex: number): 'completed' | 'running' | 'current' | 'upcoming' | 'failed' {
    if (this.stepRunning(stepIndex)) { return 'running'; }
    if (this.stepFailed(stepIndex)) { return 'failed'; }
    const pointer = this.currentDrStepPointer;
    if (pointer === this.DR_STEPS.length) { return 'upcoming'; }
    if (stepIndex < pointer) { return 'completed'; }
    if (stepIndex === pointer) { return 'current'; }
    return 'upcoming';
  }

  private loadBlueprint(): void {
    this.blueprintsService.getBlueprints()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprints => {
        this.blueprint = blueprints.find(item => item.id === this.blueprintId);
        const tenantId = this.activatedRoute.snapshot.params.id;
        this.tenantId = tenantId;
        this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.tenantId] }),
        this.breadcrumbItems.push({label: translate('TENANT_LAYOUT.MENU.DISASTER_RECOVERY'), url:[RouterSegments.TENANT, tenantId, RouterSegments.DISASTER_RECOVERY]});
        this.breadcrumbItems.push({label: this.blueprint?.name});
        const liveInstance = this.blueprint?.pathToLiveConfiguration?.find(item => item.deploymentClass === DeploymentClass.A);
        if (liveInstance && liveInstance?.instanceId) {
          this.getClassAInstanceDetails(liveInstance?.instanceId);
        }
        this.loadService();
        this.loadInstances();
      }, (error) => {
        this.errorPageService.show404Page()
      });
  }
  
  getClassAInstanceDetails(instanceId: any, forceActivityLoad: boolean = false) {
    this.instanceService.getInstanceDetails(instanceId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
       this.classAInstaceDetails = [data];
       this.dataLoaded = true;
       if (forceActivityLoad || this.isInstanceInProgress(data)) {
         this.loadActivityDetails(data);
       }
       const allInstances = [...this.sharedInstanceDetails, ...this.classAInstaceDetails];
       this.disasterRecoveryService.setDrStatus(allInstances);
       setTimeout(() => {
         this.accordion?.openAll();
       }, 100);
    }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.dataLoaded = true;
      setTimeout(() => {
        this.accordion?.openAll();
      }, 100);
    });
  }

  private loadService(): void {
    const solutionId = this.blueprint?.solutionId;
    combineLatest([this.solutionsService.getSolutionById(solutionId), this.solutionsService.getSolutionVersions(solutionId)])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([solution, solutionVersions]) => {
        this.solution = solution;
        this.solutionVersions = solutionVersions;
        this.viewReleaseNotes = this.solutionVersions[this.solutionVersions.length - 1]?.releaseNotes;
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  private loadInstances(forceActivityLoad: boolean = false): void {
    const obj = {
      blueprintId: this.blueprintId,
      tenantId: this.tenantId
    };
    this.instanceService.getInstances(obj)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
      this.instances = instances.data;
      const liveInstance = this.blueprint?.pathToLiveConfiguration?.find(item => item.deploymentClass === DeploymentClass.A);
      if (!liveInstance || (liveInstance && !liveInstance?.instanceId)) {
        this.classAInstaceDetails = this.instances?.filter(item => item?.deploymentClass === DeploymentClass.A && item.id);
        this.classAInstaceDetails?.forEach((inst: any) => {
          if (forceActivityLoad || this.isInstanceInProgress(inst)) {
            this.loadActivityDetails(inst);
          }
        });
        this.dataLoaded = true;
        setTimeout(() => {
          this.accordion?.openAll();
        }, 100);
      }
      this.dataLoaded = true;
      const allInstances = [...(this.sharedInstanceDetails || []), ...(this.classAInstaceDetails || []), ...(this.instances || [])];
      this.disasterRecoveryService.setDrStatus(allInstances);
      this.isLive = this.resolveLiveStatus(this.instances);
      if (this.solution && this.solutionVersions) {
        this.serviceVersionsInfo = this.solutionVersionsService.getSolutionVersionsInfo(this.solution, this.solutionVersions, this.instances);
        const liveInstance = this.instances.find(instance => instance.deploymentClass === DeploymentClass.A);
        if (liveInstance) {
          this.latestReleaseVersion = this.solutionVersions.filter(version =>
            version.id === liveInstance.solutionVersionId)[0]?.releaseVersion;
        } else {
          const instanceLength = this.instances.length;
          const latestInstanceSolutionVersion = this.instances[instanceLength - 1]?.solutionVersionId;
          this.latestReleaseVersion = this.solutionVersions.filter(version =>
            version.id === latestInstanceSolutionVersion)[0]?.releaseVersion;
        }
        let releaseVersionText;
        if (this.latestReleaseVersion) {
          releaseVersionText = this.latestReleaseVersion;
        } else {
          releaseVersionText = this.serviceVersionsInfo?.currentVersion?.releaseVersion;
        }
        this.isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
      }
    }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      this.dataLoaded = true;
      setTimeout(() => {
        this.accordion?.openAll();
      }, 100);
    });
  }

  private resolveLiveStatus(instances: any[]): boolean {
    const live = instances?.find(instance => instance.deploymentClass === DeploymentClass.A);
    return this.INSTANCE_DEPLOYED_STATES.includes(live?.status);
  }

  public menuItemClicked(item) {
    this.selectedMenu = item;
  }

  getDrState(instance: any): string | null {
    if (instance?.drState) {
      return instance.drState;
    }
    return instance?.lastOperation?.type ?? null;
  }

  isOperationSuccessful(instance: any): boolean {
    const lastOp: LastOperation = instance?.lastOperation;
    const status = lastOp?.status?.toLowerCase();
    return status === 'succeeded' || status === 'success';
  }

  private isOperationFailed(instance: any): boolean {
    const lastOp: LastOperation = instance?.lastOperation;
    return lastOp?.status?.toLowerCase() === 'failed';
  }

  private isDrBlocked(instance: any): boolean {
    const drState = this.getDrState(instance);
    if (!drState) {
      return false;
    }
    const blockedDrTypes = ['INSTANCE_SUMMARY.TABLE.INITIALIZE', this.DrStates.FAILOVER, this.DrStates.PRE_FALLBACK, this.DrStates.FALLBACK];
    return blockedDrTypes.includes(drState as any);
  }

  private isFailoverFailed(instance: any): boolean {
    const drState = this.getDrState(instance);
    return drState === this.DrStates.FAILOVER && this.isOperationFailed(instance);
  }

  canShowStartFailover(instance: any): boolean {
    const drState = this.getDrState(instance)?.toLowerCase();
    if (drState === 'failover' && this.isOperationSuccessful(instance)) { return false; }
    if (drState === 'pre_fallback' || drState === 'fallback') { return false; }
    if (drState === 'post_fallback') {
    if (instance?.status === this.DrStatus.POST_FALLBACK_INPROGRESS) { return false; }
      return true;
    }
    return true;
}

    canAccessFeature(flagId: string): boolean {
    const isEnabled = this.featureFlagsManagerService.isFeatureEnabled(flagId);
    return isEnabled;
  }

  startDrAction(instance, section): void {
    
    let title;
    let message;
    let dialogAction = '';
    if (section === 'classA' && !this.hasSharedTss()) {
      this.openGenericError();
      return;
    }
    const drState = this.getDrState(instance);
    const isInitialState = !this.isDrBlocked(instance) && !this.isFailoverFailed(instance);
          const hasFlagsLoaded = this.featureFlagsManagerService.hasFeatureFlags();
          if (hasFlagsLoaded) {
            this.isDrFeatureEnabled = this.canAccessFeature(FeatureFlags.DR_MODE_SELECTION);
          }
        
    if (isInitialState) {
      if ((section === 'shared' && (instance?.status === this.DrStatus.FAILOVER_INPROGRESS || (this.classAInstaceDetails?.length > 0 && this.drStates.includes(this.getDrState(this.classAInstaceDetails[0])) && (this.getDrState(this.classAInstaceDetails[0]) !== this.DrStates.POST_FALLBACK || this.classAInstaceDetails[0].status === this.DrStatus.POST_FALLBACK_INPROGRESS ||
        this.classAInstaceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ||
      (section === 'classA' && (instance?.status === this.DrStatus.FAILOVER_INPROGRESS || (this.sharedInstanceDetails?.length > 0 && (this.getDrState(this.sharedInstanceDetails[0]) !== this.DrStates.FAILOVER || this.sharedInstanceDetails[0].status === this.DrStatus.FAILOVER_INPROGRESS ||
        this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status)))) {
        this.openGenericError();
        return;
      } else {
        title = translate('DISASTER_RECOVERY.START_FAILOVER') + ' ?';
        message = translate('DISASTER_RECOVERY.START_FAILOVER_CONFIRMATION');
        dialogAction = this.DrActions.FAILOVER;
      }
    } else if (drState === this.DrStates.FAILOVER && (this.isOperationSuccessful(instance) || this.isOperationFailed(instance))) {
      if ((section === 'shared' && (instance?.status === this.DrStatus.PRE_FALLBACK_INPROGRESS || (this.classAInstaceDetails?.length > 0 && (!(this.getDrState(this.classAInstaceDetails[0]) === this.DrStates.FAILOVER || this.getDrState(this.classAInstaceDetails[0]) === this.DrStates.PRE_FALLBACK) || this.classAInstaceDetails[0].status === this.DrStatus.FAILOVER_INPROGRESS ||
        this.classAInstaceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ||
      (section === 'classA' && (instance?.status === this.DrStatus.PRE_FALLBACK_INPROGRESS || (this.classAInstaceDetails?.length > 0 && (this.getDrState(this.classAInstaceDetails[0]) !== this.DrStates.FAILOVER || this.classAInstaceDetails[0].status === this.DrStatus.FAILOVER_INPROGRESS ||
        this.classAInstaceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status)))) {
        this.openGenericError();
        return;
      } else {
        title = translate('DISASTER_RECOVERY.START_PREFALLBACK') + ' ?';
        message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
        dialogAction = this.DrActions.PRE_FALLBACK;
      }
    } else if (drState === this.DrStates.PRE_FALLBACK && (this.isOperationSuccessful(instance) || this.isOperationFailed(instance))) {
      if ((section === 'shared' && (instance?.status === this.DrStatus.FALLBACK_INPROGRESS || (this.classAInstaceDetails?.length > 0 && (this.getDrState(this.classAInstaceDetails[0]) !== this.DrStates.PRE_FALLBACK || this.classAInstaceDetails[0].status === this.DrStatus.PRE_FALLBACK_INPROGRESS || this.classAInstaceDetails[0].status === DeployStatus.FAILED)) ||
        (this.sharedInstanceDetails?.length > 0 && (this.getDrState(this.sharedInstanceDetails[0]) !== this.DrStates.PRE_FALLBACK || this.sharedInstanceDetails[0].status === this.DrStatus.PRE_FALLBACK_INPROGRESS ||
          this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) ||
      (section === 'classA' && (instance?.status === this.DrStatus.FALLBACK_INPROGRESS || (this.sharedInstanceDetails?.length > 0 && (!(this.getDrState(this.sharedInstanceDetails[0]) === this.DrStates.FALLBACK || this.getDrState(this.sharedInstanceDetails[0]) === this.DrStates.POST_FALLBACK) ||
          this.sharedInstanceDetails[0].status === this.DrStatus.FALLBACK_INPROGRESS || this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status)))) {
        this.openGenericError();
        return;
      } else {
        title = translate('DISASTER_RECOVERY.START_FALLBACK') + ' ?';
        message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
        dialogAction = this.DrActions.FALLBACK;
      }
    } else if (drState === this.DrStates.FALLBACK && (this.isOperationSuccessful(instance) || this.isOperationFailed(instance))) {
      if ((section === 'shared' && (instance?.status === this.DrStatus.POST_FALLBACK_INPROGRESS || (this.sharedInstanceDetails?.length > 0 && (this.getDrState(this.sharedInstanceDetails[0]) !== this.DrStates.FALLBACK || this.sharedInstanceDetails[0].status === this.DrStatus.FALLBACK_INPROGRESS || this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status))) || (section === 'classA' && (instance?.status === this.DrStatus.POST_FALLBACK_INPROGRESS || (this.sharedInstanceDetails?.length > 0 &&
          (this.getDrState(this.sharedInstanceDetails[0]) !== this.DrStates.POST_FALLBACK || this.sharedInstanceDetails[0].status === this.DrStatus.POST_FALLBACK_INPROGRESS || this.sharedInstanceDetails[0].status === DeployStatus.FAILED)) || (this.classAInstaceDetails?.length > 0 &&
          (this.getDrState(this.classAInstaceDetails[0]) !== this.DrStates.FALLBACK || this.classAInstaceDetails[0].status === this.DrStatus.FALLBACK_INPROGRESS || this.classAInstaceDetails[0].status === DeployStatus.FAILED)) || !this.checkEligibleStatus(instance?.status)))) {
        this.openGenericError();
        return;
      } else {
        title = translate('DISASTER_RECOVERY.START_POSTFALLBACK') + ' ?';
        message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
        dialogAction = this.DrActions.POST_FALLBACK;
      }
    }
    if (this.isDrFeatureEnabled && section === 'classA' && (dialogAction === this.DrActions.FAILOVER || dialogAction === this.DrActions.FALLBACK)) {
      const drFailedStates = [DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_FAILED];
      const isFailedDrState = drFailedStates.includes(instance?.status);
      const instanceDrMode = isFailedDrState ? instance?.drMode : null;
      const drModeOptions = [
        { label: translate('DISASTER_RECOVERY.PLANNED_MAINTENANCE'), value: this.DrModes.PLANNED, selected: instanceDrMode ? instanceDrMode === this.DrModes.PLANNED : false },
        { label: translate('DISASTER_RECOVERY.UNPLANNED_OUTAGE'), value: this.DrModes.UNPLANNED, selected: instanceDrMode ? instanceDrMode === this.DrModes.UNPLANNED : false }
      ];

      const drMessage = translate('DISASTER_RECOVERY.INITIATE_ACTION', { action: dialogAction });
      const drAckText = translate('DISASTER_RECOVERY.UNDERSTAND_ACTION', { action: dialogAction });

      this.dialog.open(DrModeDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '665px',
        height: '471px',
        autoFocus: false,
        data: {
          title: translate('DISASTER_RECOVERY.DISASTER_RECOVERY'),
          message: drMessage,
          confirmButtonText: translate('BUTTONS.CONFIRM'),
          cancelButtonText: translate('BUTTONS.CANCEL'),
          optionSelection: drModeOptions,
          drDetails: {
            environment: instance?.name,
            type: '-',
            from: `${instance?.primaryRegion || instance?.primaryCloudRegion || '-'} (Primary)`,
            to: `${instance?.secondaryRegion || instance?.secondaryCloudRegion || '-'} (Secondary)`
          },
          drAckText: drAckText
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(selectedOption => {
          if (selectedOption && selectedOption.value) {
            const drMode = selectedOption.value;
            if (dialogAction === this.DrActions.FAILOVER) {
              this.startFailover(instance, section, drMode);
            } else if (dialogAction === this.DrActions.FALLBACK) {
              this.startFallback(instance, section, drMode);
            }
          }
        });
    } else {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: ['default-dialog-wrapper', 'dr-confirmation-dialog'],
      width: '566px',
      autoFocus: false,
      data: {
        title,
        message,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          if (isInitialState) {
            this.startFailover(instance, section);
          } else if (drState === this.DrStates.FAILOVER && this.isOperationSuccessful(instance)) {
            this.startPreFallback(instance, section);
          } else if (drState === this.DrStates.PRE_FALLBACK && this.isOperationSuccessful(instance)) {
            this.startFallback(instance, section);
          } else if (drState === this.DrStates.FALLBACK && this.isOperationSuccessful(instance)) {
            this.startPostFallback(instance, section);
          }
        }
      });
    }
  }

  startFailover(instance, section, drMode?: string): void {
    this.disasterRecoveryService.setDrInProgress(this.blueprintId);
    this.instanceService.putFailover(instance?.id, drMode)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.refreshInstances(true);
    }, (error) => {
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.START_FAILOVER_FAILED'),
          description: errorMessage
        }
      });
    });
  }

  startPreFallback(instance, section): void {
    this.disasterRecoveryService.setDrInProgress(this.blueprintId);
    this.instanceService.putPreFallback(instance?.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.refreshInstances(true);
    }, (error) => {
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.START_PREFALLBACK_FAILED'),
          description: errorMessage
        }
      });
    });
  }

  startFallback(instance, section, drMode?: string): void {
    this.disasterRecoveryService.setDrInProgress(this.blueprintId);
    this.instanceService.putFallback(instance?.id, drMode)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.refreshInstances(true);
    }, (error) => {
      const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.START_FALLBACK_FAILED'),
          description: errorMessage
        }
      });
    });
  }

  startPostFallback(instance, section): void {
    this.disasterRecoveryService.setDrInProgress(this.blueprintId);
    this.instanceService.putPostFallback(instance?.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.refreshInstances(true);
    }, (error) => {
       const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title: translate('ERROR_DIALOG.START_FALLBACK_FAILED'),
          description: errorMessage
        }
      });
    });
  }

  refreshInstances(forceActivityLoad = false): void {
    this.dataLoaded = false;
    this.count = this.count !== 1 ? 1 : 0;
    Object.keys(this.instanceIdsObj).forEach(key => {
      if (this.instanceIdsObj[key]) {
        this.getSharedInstanceDetails(this.instanceIdsObj[key], forceActivityLoad);
      }
    });
    const liveInstance = this.blueprint?.pathToLiveConfiguration?.find(item => item.deploymentClass === DeploymentClass.A);
    if (liveInstance && liveInstance?.instanceId) {
      this.getClassAInstanceDetails(liveInstance?.instanceId, forceActivityLoad);
    } else {
      this.loadInstances(forceActivityLoad);
    }
  }
  
   checkEligibleStatus(status): any {
    if (this.DrNotEligibleStatus.includes(status)) {
      return false;
    } else {
      return true;
    }
  }

  openGenericError(): void {
    this.dialog.open(GenericErrorComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog'
    });
  }

  getDifferenceBetweenDates(date): any {
    const todayDate = new Date();
    const remainingTime = Math.round(moment.duration(moment(todayDate).diff(date)).asSeconds());
    return remainingTime < (60 * 5);
  }

  getButtonText(state): any {
    if (state === this.DrStates.FAILOVER) {
      return 'DISASTER_RECOVERY.FAIL_OVER';
    } else if (state === this.DrStates.FALLBACK) {
      return 'DISASTER_RECOVERY.FALLBACK'
    } else if (state === this.DrStates.PRE_FALLBACK) {
      return 'DISASTER_RECOVERY.PRE_FALLBACK'
    } else if (state === this.DrStates.POST_FALLBACK) {
      return 'DISASTER_RECOVERY.POST_FALLBACK'
    }
  }

  retryDrAction(instance, section): void {
    let title;
    let message;
    if (section === 'classA' && !this.hasSharedTss()) {
      this.openGenericError();
      return;
    }
    const drState = this.getDrState(instance);
    if (drState === this.DrStates.FAILOVER) {
      title = translate('DISASTER_RECOVERY.START_FAILOVER') + ' ?';
      message = translate('DISASTER_RECOVERY.START_FAILOVER_CONFIRMATION');
    } else if (drState === this.DrStates.PRE_FALLBACK) {
      title = translate('DISASTER_RECOVERY.START_PREFALLBACK') + ' ?';
      message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
    } else if (drState === this.DrStates.FALLBACK) {
      title = translate('DISASTER_RECOVERY.START_FALLBACK') + ' ?';
      message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
    } else if (drState === this.DrStates.POST_FALLBACK) {
      title = translate('DISASTER_RECOVERY.START_POSTFALLBACK') + ' ?';
      message = translate('DISASTER_RECOVERY.START_FALLBACK_CONFIRMATION');
    }
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: ['default-dialog-wrapper', 'dr-confirmation-dialog'],
      width: '566px',
      autoFocus: false,
      data: {
        title,
        message,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          if (drState === this.DrStates.FAILOVER) {
            this.startFailover(instance, section);
          } else if (drState === this.DrStates.PRE_FALLBACK) {
            this.startPreFallback(instance, section);
          } else if (drState === this.DrStates.FALLBACK) {
            this.startFallback(instance, section);
          } else if (drState === this.DrStates.POST_FALLBACK) {
            this.startPostFallback(instance, section);
          }
        }
      });
  }

  openInstanceDetails(instance, type?): void {
    if (type === 'tss') {
      const obj: any = {
        id: instance.id,
        blueprintId: this.blueprintId
      }
      localStorage.setItem('DrBlueprint', JSON.stringify(obj));
    }
    const tenantId = this.activatedRoute.snapshot.params.id;
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, tenantId, RouterSegments.BLUEPRINTS,
      this.blueprintId, RouterSegments.ENVIRONMENT, instance.id],{queryParams: { fromDR: true }});
  }

 get classADrMode(): string {
    return this.classAInstaceDetails?.[0]?.drMode ?? this.DrModes.PLANNED;
  }

  shouldShowClassADrMode(): boolean {
    if (!this.classADrMode || !this.classAInstaceDetails?.length) {
      return false;
    }
    const instance = this.classAInstaceDetails[0];
    const drState = this.getDrState(instance);

    if (drState === this.DrStates.FAILOVER) {
      return true;
    }
    if (drState === this.DrStates.PRE_FALLBACK && instance?.status === this.DrStatus.PRE_FALLBACK_INPROGRESS) {
      return true;
    }
    if (drState === this.DrStates.FALLBACK) {
      return true;
    }
    if (drState === this.DrStates.POST_FALLBACK && instance?.status === this.DrStatus.POST_FALLBACK_INPROGRESS) {
      return true;
    }
    return false; 
  }

   private loadActivityDetails(instance: any): void {
    if (!instance?.id) { return; }
    const instanceId = instance.id;
    this.activityService.getInstanceActivityLogs(instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((activityLogs: any) => {
        const logs = Array.isArray(activityLogs) ? activityLogs : (activityLogs?.data ?? []);
        if (!logs?.length) { return; }

        const latestLog = [...logs].sort((a, b) =>
          new Date(b?.startTime).getTime() - new Date(a?.startTime).getTime()
        )[0];
        if (!latestLog?.id) { return; }

        this.activityService.getInstanceActivityLogsById(instanceId, latestLog.id)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((activityLogDetails: any) => {
            const target = this.sharedInstanceDetails?.find((i: any) => i.id === instanceId)
              ?? this.classAInstaceDetails?.find((i: any) => i.id === instanceId)
              ?? instance;

            instance.activityDetails = activityLogDetails;
            const stages: any[] = activityLogDetails?.stages ?? [];
            const activeStage = stages.find(s => s.type === 'component_execution');

            target.activityDetails = activityLogDetails;
            target.activityDetails.countData = {};

            if (activeStage?.count?.total) {
              const total = Number(activeStage.count.total);
              const completed = Number(activeStage.count.completed ?? 0);
              const skipped = Number(activeStage.count.skipped ?? 0);
              target.activityDetails.countData.total = total;
              target.activityDetails.countData.completedPercent =
                completed !== 0 ? Math.round(((completed + skipped) / total) * 100) : 0;
            }
              target.activityStartTime = latestLog.startTime;
              target.expectedDurationMs = latestLog.expectedDurationMs;
              if (latestLog?.count && latestLog?.count?.total) {
                target.total = Number(latestLog.count.total);
                target.completed = Number(latestLog.count.completed ?? 0);
                target.skipped = Number(latestLog.count.skipped ?? 0);
                target.pending = Number(target.total - (target.completed + target.skipped));
                target.completedPercent = target?.completed !== 0 ? Math.round(((target?.completed + target?.skipped) / target.total) * 100) : 0;
              }
          });
      });
  }

  getInProgressInstance(instances: any[]): any {
    return instances?.find(inst => this.isInstanceInProgress(inst));
  }


  openActivityDetails(instanceData: any) {
    const data = {
      activityDetail: {
        ...instanceData?.activityDetails,
        startTime: instanceData?.activityStartTime ?? instanceData?.activityDetails?.startTime,
        expectedDurationMs: instanceData?.expectedDurationMs ?? instanceData?.activityDetails?.expectedDurationMs
      },
      instance: {
        ...instanceData,
        status: translate(this.statusText[instanceData?.status] ?? instanceData?.status)
      }
    }
    this.sidenavService.openInRightSidenav(EnvironmentActivityDetails, data, "activityDetails")
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((detail) => {
      const arrays = [{ data: this.sharedInstanceDetails, update: (data: any[]) => this.sharedInstanceDetails = data},
      { data: this.classAInstaceDetails, update: (data: any[]) => this.classAInstaceDetails = data},
      ];
      const matchedArray = arrays.find(group => group.data?.some(item => item.id === detail?.instanceId));
      if (!matchedArray) {return;}
      const updatedArray = this.activityProgressService.updateInstanceActivityDetail(matchedArray.data,detail);
      matchedArray.update(updatedArray);
    });
  }

  hasSharedTss(): boolean {
    return !!this.instanceIdsObj?.sharedServicesInstance;
  }

}